// src/App.js
import React, { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Home from './components/Home';
import PuzzlePage from './components/PuzzlePage';
import PlayPuzzlePage from './components/PlayPuzzlePage';
import TermsAndConditions from './components/TermsAndConditions';
import MembersBenefitsPage from './components/MemberBenefitsPage';
import DailyWordPuzzle from './components/DailyWordPuzzle';   // ⬅️ NEW
import Header from './components/Header';
import Footer from './components/Footer';
import LoginPage        from './components/LoginPage';
import RegisterPage     from './components/RegisterPage';
import MemberBenefits   from './components/MemberBenefitsPage'; // created earlier
import AdminLogin from './components/AdminLogin';
import AdminScheduler from './components/AdminScheduler';
import DailyPuzzle from './components/DailyPuzzle'; // adjust path as needed
import ResetPassword from './components/ResetPassword';
import CreatePuzzleGift from './components/CreatePuzzleGift';
import PlayPuzzleCard from './components/PlayPuzzleCard'; // You'll need to build this page
import AlphabetA from './components/AlphabetA';
import AlphabetLessonA from './components/AlphabetLessonA';
 

function App() {
  const [image, setImage] = useState(null);
  const [message, setMessage] = useState('');
  const [gridSize, setGridSize] = useState(3);
  const [fontStyle, setFontStyle] = useState('serif');

  const resetForm = () => {
    setImage(null);
    setMessage('');
    setGridSize(3);
    setFontStyle('serif');
  };

  return (
    <>
      <Header />

      <Routes>
        <Route
          path="/"
          element={
            <Home
              image={image}
              setImage={setImage}
              message={message}
              setMessage={setMessage}
              gridSize={gridSize}
              setGridSize={setGridSize}
              fontStyle={fontStyle}
              setFontStyle={setFontStyle}
            />
          }
        />

        <Route
          path="/puzzle"
          element={
            <PuzzlePage
              image={image}
              message={message}
              gridSize={gridSize}
              fontStyle={fontStyle}
              resetForm={resetForm}
            />
          }
        />

        <Route path="/play/:id" element={<PlayPuzzlePage />} />
        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/benefits" element={<MembersBenefitsPage />} />
        <Route path="/create-puzzle-gift" element={<CreatePuzzleGift />} />  
        {/* 🔹 New daily word puzzle route */}
        <Route path="/thedailywordpuzzle" element={<DailyWordPuzzle />} />
        <Route path="/DailyPuzzle" element={<DailyPuzzle />} />
        <Route path="/create-puzzle-gift" element={<CreatePuzzleGift />} />
        <Route path="/play-puzzle-card/:id" element={<PlayPuzzleCard />} />

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" />} />

        {/* Registration and Login */}

        <Route path="/benefits"  element={<MemberBenefits />} />
        <Route path="/login"     element={<LoginPage />} />
        <Route path="/register"  element={<RegisterPage />} />
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/admin-scheduler" element={<AdminScheduler />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/learn/alphabet/a" element={<AlphabetA />} />
         <Route path="/learn/alphabetLesson/a" element={<AlphabetLessonA />} />

      </Routes>

      <Footer />
    </>
  );
}

export default App;
